import React from 'react';
import { faLocationArrow, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Alert, Button, Col, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import messages from '../../constants/messages';
import es from '../../lang/es';

import { listHistoryAction } from '../../actions/proceedingActions';
import ProceedingListMobile from './ProceedingListMobile';

const ProceedingList = ({ proceedings, filter, initPage, handleLoadMore }) => {
    //Inicio history
    const history = useHistory();
    //Inicializo el dispath
    const dispatch = useDispatch();
    //Manejo la selección de expediente
    const handleSelect = proceeding => {
        //Llamo al disppatch
        dispatch( listHistoryAction(proceeding, history) );
    }
    //Render
    return (
        <Col xs={12}>
            {
                proceedings.length > 0 ? (
                    <Row>
                        <Col xs={12}>
                            <Table bordered hover size="sm" responsive className="d-none d-md-table">
                                <thead className="thead-light">
                                    <tr>
                                        <th>{ es.FIELDS.EXPTE }</th>
                                        <th>{ es.FIELDS.COVER }</th>
                                        <th>{ es.FIELDS.PROCEEDING }</th>
                                        <th>{ es.FIELDS.UNIT }</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        proceedings.map(proceeding => (
                                            <tr key={`procid${proceeding.procid}`}>
                                                <td className="align-middle text-center">
                                                    <small>{ proceeding.nro_expediente }</small>
                                                </td>
                                                <td className="align-middle">
                                                    <small>{ proceeding.caratula }</small>
                                                </td>
                                                <td className="align-middle text-center">
                                                    <small>{ proceeding.tipo_proceso }</small>
                                                </td>
                                                <td className="align-middle text-center">
                                                    <small>{ proceeding.juzgado.coju }</small>
                                                </td>
                                                <td className="align-middle text-center">
                                                    <OverlayTrigger
                                                        key={`p-${proceeding.procid}`}
                                                        placement="left"
                                                        overlay={
                                                            <Tooltip id={`tooltipProc-${proceeding.procid}`}>
                                                                { es.VIEW_HISTORY.toUpperCase() }
                                                            </Tooltip>
                                                        }
                                                    >
                                                    <Button variant="info" size="sm" onClick={ () => handleSelect(proceeding) }>
                                                        <FontAwesomeIcon icon={ faLocationArrow } />
                                                    </Button>
                                                    </OverlayTrigger>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>
                            <ProceedingListMobile
                                proceedings={ proceedings }
                                handleSelect={handleSelect}
                            />
                        </Col>
                        {
                            ((filter.page === initPage && proceedings.length === parseInt(process.env.REACT_APP_PAGE_SIZE)) || (filter.page > initPage && (filter.page * parseInt(process.env.REACT_APP_PAGE_SIZE) <= proceedings.length))) ? (
                                <Col xs={12}>
                                    <Button  variant="primary" size="sm" onClick={handleLoadMore}>
                                        <FontAwesomeIcon icon={ faRedoAlt } /> { es.LOAD_MORE.toUpperCase() }
                                    </Button>
                                </Col>
                            ) : null
                        }
                    </Row>
                ) : (
                    <Alert variant="warning">
                        { messages.NOT_RECORDS }
                    </Alert>
                )
            }
        </Col>
    );
};

export default ProceedingList;